<template>
  <div class='coursework-viewer__slide'>
    <pre class='coursework-viewer__text-container' v-bind:class='codeClass'>
      <code ref='codeEl'></code>
    </pre>
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    computed: {
      codeClass() {
        return `language-${this.media.meta.h_lang}`
      }
    },
    methods: {
      init() {
        let request = new Kadenze.AjaxRequest({
          type: 'GET',
          data: null,
          dataType: 'text',
          dataAsJSON: false,
          url: this.media.file.url
        });

        request.done((response) => {
          $(this.$refs['codeEl']).text(response);
          Prism.highlightElement(this.$el);
          setTimeout(() => {
            this.$emit('ready', this.media.id)
          }, 100);
        });
      }
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {
      this.init();
    }
  }
</script>